import React from 'react';
import Async from 'react-select/async';
import { userStore } from 'components/users/UserStore';
import UserProfileAvatar from 'ats/components/user-profile-avatar/UserProfileAvatar';
import MultiDropdownGroupedAsync from 'ats/components/multi-dropdown-grouped/MultiDropdownGroupedAsync';
import { reactSelectAtsComponents } from 'ats/components/react-select/reactSelectAtsComponents';

export class UsersDropdown extends React.Component {
	static defaultProps = {
		minSearchChars: 3
	};

	state = {
		value: null,
		loaded: false
	};
	async componentDidMount() {
		if (this.props.value) {
			this.setState({ value: this.props.value });
		}
		this.setState({ loaded: true });
	}

	render() {
		if (this.state.loaded) {
			const { isMulti, minSearchChars } = this.props;
			const searchOnOpen = minSearchChars === 0;
			// Multi-select uses the grouped async wrapper so currently selected
			// users are pinned at the top and the count pill is rendered.
			const Component = isMulti ? MultiDropdownGroupedAsync : Async;

			return (
				<Component
					menuPosition={this.props.menuPosition || 'fixed'}
					menuPlacement={this.props.menuPlacement || 'auto'}
					closeMenuOnScroll={this.props.closeMenuOnScroll}
					menuPortalTarget={this.props.menuPortalTarget}
					maxMenuHeight="300"
					defaultOptions={searchOnOpen || undefined}
					className={
						'react-select ' +
						(isMulti ? 'ats-multi-dropdown ats-multi-dropdown-grouped ' : '') +
						(this.props.styleVersion ? this.props.styleVersion : '')
					}
					classNamePrefix={
						this.props.classNamePrefix ||
						'react-select' +
							(this.props.styleVersion ? `-${this.props.styleVersion}` : '')
					}
					cacheOptions
					value={
						this.props.value === undefined ? this.state.value : this.props.value
					}
					placeholder={this.props.placeholder || 'Users'}
					isMulti={isMulti}
					isClearable={this.props.isClearable}
					isDisabled={this.props.disabled}
					components={isMulti ? undefined : reactSelectAtsComponents}
					styles={{
						container: (base, state) => ({
							...base,
							...(state.isDisabled && {
								opacity: 0.5,
								cursor: 'not-allowed'
							})
						}),
						control: (base, state) => ({
							...base,
							paddingRight: 12,
							...(state.isFocused && {
								borderColor: '#6938EF',
								boxShadow: '0 0 0 1px #6938EF'
							}),
							...(this.props.customStyles?.control || {})
						}),
						option: (base, state) => ({
							...base,
							...(state.isFocused && {
								backgroundColor: '#F4F3FF'
							}),
							':active': {
								...base[':active'],
								backgroundColor: '#EBE9FE'
							}
						})
					}}
					loadOptions={this.loadOptions}
					getOptionValue={this.getOptionValue}
					getOptionLabel={this.getOptionLabel}
					noOptionsMessage={this.noOptionsMessage}
					onChange={item => {
						if (this.props.onValueChange) {
							this.props.onValueChange(item);
						}
						this.setState({ value: item });
					}}
				/>
			);
		} else {
			return null;
		}
	}

	loadOptions = inputValue => {
		return new Promise(resolve => {
			resolve(this.getUsers(inputValue));
		});
	};

	getUsers = async inputValue => {
		inputValue = inputValue.trim();
		const result = await userStore.getUsers({
			text: inputValue,
			role: this.props.role
		});

		const excludeUserIds = this.props.excludeUserIds || [];
		const filteredUsers = result.data.rows.filter(
			user => !excludeUserIds.includes(user.id)
		);

		return filteredUsers;
	};

	noOptionsMessage = value => {
		const minSearchChars = this.props.minSearchChars;
		if (minSearchChars === 0) {
			return 'No matches found';
		}

		if (value.inputValue && value.inputValue.trim().length >= minSearchChars) {
			return 'No matches found';
		}

		return `Type at least ${minSearchChars} characters to search users`;
	};

	getOptionValue = option => option.id;

	getOptionLabel = option => {
		return this.props.showAvatar ? (
			<UserProfileAvatar
				imageUrl={option.imageUrl}
				name={option.name}
				showName
			/>
		) : (
			option.name
		);
	};
}
